import api from "../../services/api";

// `ticketId`: na conversa aberta pelo acesso por filial, o backend devolve as etapas do funil do ticket.
const useQueuesFunil = (userId, funil_icode, ticketId) => {
    let data = {};
    data.userId = userId;
	const findAll = async () => {
        const { data } = await api.get(`/queueUser/${userId}/${funil_icode}`, {
            params: ticketId ? { ticketId } : {}
        });
        return data;
    }

	return { findAll };
};

export default useQueuesFunil;
